import {LeftOutlined} from '@ant-design/icons';
import Academy from 'assets/icons/login/academy.svg';

const AcademyLink: React.FC = () => {
  return (
    <a
      className="flex w-full cursor-pointer flex-col items-center justify-center gap-2.5 rounded-sm border border-gray-03 bg-white py-2"
      href="https://express.snapp.market/academy/"
      target="_blank"
      rel="noreferrer"
    >
      <img className="size-8" src={Academy} alt="" />
      <span className="flex items-center gap-2 text-body-xs text-gray-07">
        آکادمی اسنپ‌اکسپرس
        <LeftOutlined aria-hidden />
      </span>
    </a>
  );
};

export default AcademyLink;
